/**
 * Ensures a domain URL has the given scheme. If the URL already includes a
 * scheme (e.g. `http://` from DEVELOPMENT_INGRESS_DOMAIN), it is returned
 * as-is. Otherwise the provided default scheme is prepended.
 */
export function withScheme(
  domain: string,
  defaultScheme: 'https' | 'wss',
): string {
  if (/^https?:\/\//.test(domain)) {
    // Already has an HTTP(S) scheme. If caller wanted wss, map http->ws, https->wss.
    if (defaultScheme === 'wss') {
      return domain
        .replace(/^http:\/\//, 'ws://')
        .replace(/^https:\/\//, 'wss://')
    }
    return domain
  }
  if (/^wss?:\/\//.test(domain)) {
    return domain
  }
  return `${defaultScheme}://${domain}`
}
